import React from "react";

export const BUILD_STEPS = [
  { key: "predict", label: "Predicting duration (P)" },
  { key: "timeline", label: "Drafting timeline" },
  { key: "finalize", label: "Finalizing roadmap" },
];

export const RoadmapProgress = ({ steps }) => (
  <ul className="space-y-2">
    {steps.map((s) => (
      <li key={s.key} className="flex items-start gap-2">
        {s.status === "working" && (
          <span className="mt-1 h-4 w-4 rounded-full border-2 border-gray-300 border-t-transparent animate-spin" />
        )}
        {s.status === "done" && <span className="mt-0.5">✅</span>}
        {s.status === "error" && <span className="mt-0.5">⚠️</span>}
        {(!s.status || s.status === "pending") && <span className="mt-0.5">•</span>}
        <div>
          <div className="text-sm font-medium">{s.label}</div>
          {s.detail && <div className="text-xs text-gray-500">{s.detail}</div>}
        </div>
      </li>
    ))}
  </ul>
);
